module.exports = __webpack_public_path__ + "static/media/orderTaskIcon.7fe61cb1.svg";